<template>
  <div>
    <div class="bigbox">
      <div>
        <div class="shopping_box" v-if="online_shopping">
          <div class="person"><img src="@/assets/person.png" alt="" /></div>
          <div class="line">
            <div class="little_box">
              <div class="box_left">
                <!-- <div class="title">{{ online_shopping.sub_title }}</div> -->
                <div class="shopping_text">{{ online_shopping.title }}</div>
                <p v-html="online_shopping.content"></p>
                <div class="button" @click="gonext()">点击进入</div>
              </div>
              <div class="box_right">
                <img :src="$url + online_shopping.picture" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="profile" id="profiles">
          <div class="profile-left">
            <img src="@/assets/lianxis.jpg" alt="" srcset="" />
          </div>
          <div class="profile-right">
            <div class="profile-rightBox">
              <!-- <div class="profile-title">Contact Us</div> -->
              <div class="profile-title-zh">联系我们</div>
              <div class="profile-icon"></div>
              <div
                class="store-item"
                v-for="(item, index) in item"
                :key="index"
              >
                <h1>{{ item.title }}</h1>
                <!-- <div>
                  公司名稱：<span>{{ item.name }}</span>
                </div>
                <div>
                  公司邮箱：<span>{{ item.email }}</span>
                </div>
                <div>
                  商店地址：<span>{{ item.address }}</span>
                </div> -->
                <div>
                  上海杏一医疗用品贸易有限公司(上海总部)<br />
                  Shanghai MedFirst Healthcare Services Trade Ltd. <br />
                  上海市徐汇区田州路99号9幢302室 <br />
                  <a href="https://www.medfirst.com.cn" target="_blank"
                    >www.medfirst.com.cn </a
                  ><br />
                  联系电话：400-002-0585
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Shopping",
  data() {
    return {
      item: [
        {
          name: "上海杏一医疗用品贸易有限公司",
          email: "xinyi@yiliao.com",
          address: "桃園市333龜山區文化里復興一路94號1、2樓",
        },
      ],
      online_shopping: "",
    };
  },
  created() {
    this.$http
      .post("/index/news/detail", {
        type: "online_shopping",
      })
      .then((res) => {
        if (res.data.code == 0) {
          this.online_shopping = res.data.data;
        }
      });
  },
  methods: {
    gonext() {
      window.open("https://shop.medfirst.com.cn");
    },
  },
};
</script>

<style lang="scss" scoped>
.bigbox {
  margin: 106px auto 0px;
  height: 1134px;
  width: 100%;
  .shopping_box {
    position: relative;
    display: flex;
    align-items: center;
    width: 1220px;
    margin: 0 auto;
    height: 483px;
    background: #00a4a7;
    border-radius: 10px 10px 10px 10px;
    .person {
      position: absolute;
      bottom: -95px;
      left: -30px;
    }
    .line {
      margin: 0 auto;
      width: 1196px;
      height: 459px;
      border-radius: 10px 10px 10px 10px;
      border: 2px solid #ffffffa8;
      .little_box {
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 18px 18px 18px 68px;
      }
    }
    .box_left {
      // position: absolute;
      // top: 50px;
      // left: 80px;
      width: 450px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title {
        font-size: 28px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff80;
      }
      .shopping_text {
        font-size: 40px;
        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 30px;
        }
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
      p {
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        color: #ffffff;
        line-height: 1.7;
        margin-top: 30px;
        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 18px;
          line-height:  1.7;
        }
      }
      .button {
        margin-top: 30px;
        cursor: pointer;
        line-height: 46px;
        text-align: center;
        color: #ffffff;
        width: 166px;
        height: 46px;
        background: #f6aa00;
        border-radius: 4px 4px 4px 4px;
      }
    }
    .box_right {
      width: auto;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .profile {
    margin: 0 auto;
    margin-top: 145px;
    @media (min-width: 1024px) and (max-width: 1366px) {
      margin-top: 150px;
    }
    display: flex;
    align-items: center !important;
    // justify-content: center !important;
    justify-content: flex-start;
    width: 1220px;
    height: 440px;
    .profile-left {
      width: 554px;
      height: 341px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .profile-right {
      display: flex;
      align-items: center !important;
      justify-content: center !important;
      margin-left: 55px;
      width: 472px;
      font-size: 18px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      // line-height: 1.5;

      .store-item {
        width: 470px;
        // height: 180px;
        a {
          text-decoration: none;
          color: #333;
        }
        h1 {
          // margin: 30px 0 10px 0;
          margin-bottom: 30px;
          font-size: 30px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
        div {
          margin-top: 20px;
          font-size: 18px;
          font-weight: 400;
          color: #333;
          line-height: 1.7;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          color: #333333;
          span {
            font-size: 18px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 0px;
            letter-spacing: 0px;
          }
        }
        .bus {
          color: white;
          text-align: center;
          width: 132px;
          margin: 20px 0 50px;
          padding: 8px 16px;
          background: #00a4a7;
          cursor: pointer;
          border-radius: 4px 4px 4px 4px;
        }
      }
      .profile-title {
        font-size: 24px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: 0px;
      }
      .profile-title-zh {
        margin-top: 16px;
        font-size: 36px;
        @media (min-width: 1024px) and (max-width: 1366px) {
          font-size: 30px;
        }
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
      .profile-icon {
        margin-top: 16px;
        width: 272px;
        height: 8px;
        background: linear-gradient(
          90deg,
          #00a4a7 0%,
          rgba(0, 164, 167, 0) 100%
        );
        border-radius: 0px 0px 0px 0px;
      }
      .profile-text {
        margin-top: 30px;
        width: 474px;
        // height: 298px;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 1.7;
      }
    }
    .profile-rights {
      margin-left: 0px !important;
      margin-right: 53px;
    }
  }
}

@media (max-width: 768px) {
  .bigbox {
    margin: 26px auto 20px;
    height: 100%;
    width: 100%;
    .shopping_box {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      margin: 0 auto;
      height: 100%;
      background: #00a4a7;
      border-radius: 10px 10px 10px 10px;
      .person {
        position: absolute;
        bottom: -95px;
        left: -30px;
        display: none;
      }
      .line {
        margin: 0 auto;
        width: 100%;
        height: 100%;
        border-radius: 10px 10px 10px 10px;
        border: 2px solid #ffffffa8;
        .little_box {
          height: 100%;
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 100%;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 18px 18px 18px 18px;
        }
      }
      .box_left {
        // position: absolute;
        // top: 50px;
        // left: 80px;
        width: 90%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
          font-size: 18px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff80;
        }
        .shopping_text {
          font-size: 26px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
        p {
          font-size: 18px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          color: #ffffff;
          line-height: 1.7;
          margin-top: 20px;
        }
        .button {
          margin-top: 38px;
          cursor: pointer;
          line-height: 46px;
          text-align: center;
          color: #ffffff;
          width: 166px;
          height: 46px;
          background: #f6aa00;
          border-radius: 4px 4px 4px 4px;
        }
      }
      .box_right {
        margin-top: 20px;
        width: 100%;
        height: 100%;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .profile {
      margin: 0 auto;
      margin-top: 25px;
      display: flex;
      flex-direction: column-reverse;
      align-items: center !important;
      // justify-content: center !important;
      justify-content: flex-start;
      width: 90%;
      height: 100%;
      .profile-left {
        margin-top: 20px;
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .profile-right {
        display: flex;
        align-items: center !important;
        justify-content: center !important;
        margin-left: 0px;
        width: 100%;
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        // line-height: 1.5;
        .profile-rightBox {
          width: 100%;
          height: 100%;
          // display: flex;
          // justify-content: center;
          // align-items: center;
        }

        .store-item {
          width: 90%;
          margin-right: 0px;
          // height: 180px;
          h1 {
            // margin: 30px 0 10px 0;
            margin-bottom: 30px;
            font-size: 30px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
          div {
            color: #333;
            line-height: 1.7;
            margin-top: 10px;
            font-size: 18px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            color: #333333;
            span {
              font-size: 18px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 0px;
              letter-spacing: 0px;
            }
          }
          .bus {
            color: white;
            text-align: center;
            width: 132px;
            margin: 20px 0 50px;
            padding: 8px 16px;
            background: #00a4a7;
            cursor: pointer;
            border-radius: 4px 4px 4px 4px;
          }
        }
        .profile-title {
          font-size: 24px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          // line-height: 0px;
        }
        .profile-title-zh {
          margin-top: 16px;
          font-size: 26px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }
        .profile-icon {
          margin-top: 16px;
          width: 272px;
          height: 8px;
          background: linear-gradient(
            90deg,
            #00a4a7 0%,
            rgba(0, 164, 167, 0) 100%
          );
          border-radius: 0px 0px 0px 0px;
        }
        .profile-text {
          margin-top: 30px;
          width: 100%;
          // height: 298px;
          font-size: 18px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 1.7;
        }
      }
      .profile-rights {
        margin-left: 0px !important;
        margin-right: 53px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Shopping.vue